import React, { useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import HeaderBannerPage from "../components/HeaderBannerPage";
import SupervisorWiseOT from "../components/tables/SupervisorWiseOT";
import NonAllocatedEmp from "../components/tables/NonAllocatedEmp";
import LocationBasedEmp from "../components/tables/LocationBasedEmp";
import EmpAllocation from "../components/tables/EmpAllocation";
import EmpDiscripency from "../components/tables/EmpDiscripency";
import EWODiscripency from "../components/tables/EWODiscripency";
import RosterAttendance from "../components/tables/RosterAttendance";
import RosterAbsentList from "../components/tables/RosterAbsentList";
import AbsentLast5 from "../components/tables/AbsentLast3"; // Import the new component
import AttendanceDetailsTabs from "../components/tables/AttendanceDetailsTabs";

const OTTableViews = () => {
  const [action, setAction] = useState("location");

  const handleAction = (selectedAction) => {
    setAction(selectedAction);
  };

  const buttons = [
    { label: "Employee Attendance", color: "#2563EB", action: "location" },
    
    //{ label: "Employee Allocation", color: "#B71C1C", action: "Allocation" },
    //{ label: "Supervisor Wise OT", color: "#77652aff", action: "supervisor" },
    //{ label: "OT Non Allocated", color: "#b87a15ff", action: "nonAllocated" },
    { label: "Absent List", color: "#16A34A", action: "EmpDiscripency" },
    { label: "Today Roster Attendance", color: "#DC2626", action: "rosterAttendance" },
    { label: "Roster Absent List", color: "#FF6B6B", action: "absentListRoster" }, // Added new button for RosterAbsentList
    { label: "Absenteeism Report", color: "#7C3AED", action: "absentLast5" },
    { label: "Attendance Details", color: "#0891B2", action: "attendanceDetails" }, // New tile
    // { label: "Absent Annalize", color: "#11552e", action: "EWODiscripency" },
    //{ label: "OT Non Allocated", color: "#b87a15ff", action: "nonAllocated" },
  ];

  const renderActionButtons = () => {
    const topFourButtons = buttons.slice(0, 4);
    const bottomButtons = buttons.slice(4);

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mt: 0,
          px: 0,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* First Row - 4 Buttons */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 1.5,
            width: "100%",
          }}
        >
          {topFourButtons.map((btn) => (
            <Button
              key={btn.action}
              variant="contained"
              onClick={() => handleAction(btn.action)}
              sx={{
                padding: "12px 8px",
                fontSize: "11px",
                fontWeight: "600",
                backgroundColor:
                  action === btn.action ? btn.color : "#878787ff",
                color: "#FFFFFF",
                borderRadius: "6px",
                textTransform: "none",
                transition: "all 0.3s ease",
                border: action === btn.action ? `2px solid ${btn.color}` : "2px solid #878787ff",
                minHeight: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "normal",
                lineHeight: "1.2",
                "&:hover": {
                  backgroundColor: btn.color,
                  transform: "scale(1.05)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                },
                "&:active": {
                  transform: "scale(0.98)",
                },
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Box>

        {/* Second Row - 4 Buttons with Same Gap */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 1.5,
            width: "100%",
          }}
        >
          {bottomButtons.map((btn) => (
            <Button
              key={btn.action}
              variant="contained"
              onClick={() => handleAction(btn.action)}
              sx={{
                padding: "12px 8px",
                fontSize: "11px",
                fontWeight: "600",
                backgroundColor:
                  action === btn.action ? btn.color : "#878787ff",
                color: "#FFFFFF",
                borderRadius: "6px",
                textTransform: "none",
                transition: "all 0.3s ease",
                border: action === btn.action ? `2px solid ${btn.color}` : "2px solid #878787ff",
                minHeight: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "normal",
                lineHeight: "1.2",
                "&:hover": {
                  backgroundColor: btn.color,
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                },
                "&:active": {
                  transform: "translateY(0px)",
                },
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
      }}
    >
      <HeaderBannerPage />
      <Box
        sx={{
          padding: "1px",
          fontFamily: "Arial, sans-serif",
          flex: 1,
          overflowY: "auto",
          backgroundColor: "#FFFFFF",
        }}
      >
        {renderActionButtons()}

        {action === "location" && (
          <Box sx={{ mt: 1 }}>
            <LocationBasedEmp />
          </Box>
        )}
        {action === "rosterAttendance" && (
          <Box sx={{ mt: 1 }}>
            <RosterAttendance />
          </Box>
        )}
        {action === "absentListRoster" && (
          <Box sx={{ mt: 1 }}>
            <RosterAbsentList />
          </Box>
        )}
        {action === "Allocation" && (
          <Box sx={{ mt: 1 }}>
            <EmpAllocation />
          </Box>
        )}
        {action === "supervisor" && (
          <Box sx={{ mt: 3 }}>
            <SupervisorWiseOT />
          </Box>
        )}
        {action === "nonAllocated" && (
          <Box sx={{ mt: 3 }}>
            <NonAllocatedEmp />
          </Box>
        )}
        {action === "EmpDiscripency" && (
          <Box sx={{ mt: 0 }}>
            <EmpDiscripency />
          </Box>
        )}
        {action === "EWODiscripency" && (
          <Box sx={{ mt: 3 }}>
            <EWODiscripency />
          </Box>
        )}
        {action === "absentLast5" && (
          <Box sx={{ mt: 1 }}>
            <AbsentLast5 />
          </Box>
        )}
        {action === "attendanceDetails" && (
          <Box sx={{ mt: 1 }}>
            <AttendanceDetailsTabs />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default OTTableViews;



// import React, { useState } from "react";
// import { Button, Box, Typography } from "@mui/material";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import SupervisorWiseOT from "../components/tables/SupervisorWiseOT";
// import NonAllocatedEmp from "../components/tables/NonAllocatedEmp";
// import LocationBasedEmp from "../components/tables/LocationBasedEmp";
// import EmpAllocation from "../components/tables/EmpAllocation";
// import EmpDiscripency from "../components/tables/EmpDiscripency";
// import EWODiscripency from "../components/tables/EWODiscripency";
// import RosterAttendance from "../components/tables/RosterAttendance";
// import RosterAbsentList from "../components/tables/RosterAbsentList";

// const OTTableViews = () => {
//   const [action, setAction] = useState("location");

//   const handleAction = (selectedAction) => {
//     setAction(selectedAction);
//   };

//   const buttons = [
//     { label: "Employee Attendance", color: "#2563EB", action: "location" },
//     { label: "Today Roster Attendance", color: "#DC2626", action: "rosterAttendance" },
//     //{ label: "Employee Allocation", color: "#B71C1C", action: "Allocation" },
//     { label: "Absent list", color: "#77652aff", action: "supervisor" },
//    //{ label: "OT Non Allocated", color: "#b87a15ff", action: "nonAllocated" },
//     { label: "Absent List", color: "#16A34A", action: "EmpDiscripency" },
//     { label: "Absent List (Roster)", color: "#7C3AED", action: "absentListRoster" },
//     // label: "Absent Annalize", color: "#11552e", action: "EWODiscripency" },
//     //{ label: "OT Non Allocated", color: "#b87a15ff", action: "nonAllocated" },
//   ];

//   const renderActionButtons = () => {
//     const topFourButtons = buttons.slice(0, 4);
//     const bottomButtons = buttons.slice(4);

//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           gap: 2,
//           mt: 0,
//           px: 0,
//           width: "100%",
//           boxSizing: "border-box",
//         }}
//       >
//         {/* First Row - 4 Buttons */}
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: "repeat(4, 1fr)",
//             gap: 1.5,
//             width: "100%",
//           }}
//         >
//           {topFourButtons.map((btn) => (
//             <Button
//               key={btn.action}
//               variant="contained"
//               onClick={() => handleAction(btn.action)}
//               sx={{
//                 padding: "12px 8px",
//                 fontSize: "11px",
//                 fontWeight: "600",
//                 backgroundColor:
//                   action === btn.action ? btn.color : "#878787ff",
//                 color: "#FFFFFF",
//                 borderRadius: "6px",
//                 textTransform: "none",
//                 transition: "all 0.3s ease",
//                 border: action === btn.action ? `2px solid ${btn.color}` : "2px solid #878787ff",
//                 minHeight: "60px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 whiteSpace: "normal",
//                 lineHeight: "1.2",
//                 "&:hover": {
//                   backgroundColor: btn.color,
//                   transform: "scale(1.05)",
//                   boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//                 },
//                 "&:active": {
//                   transform: "scale(0.98)",
//                 },
//               }}
//             >
//               {btn.label}
//             </Button>
//           ))}
//         </Box>

//         {/* Second Row - 2 Buttons with Same Gap */}
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: "repeat(2, 1fr)",
//             gap: 1.5,
//             width: "100%",
//           }}
//         >
//           {bottomButtons.map((btn) => (
//             <Button
//               key={btn.action}
//               variant="contained"
//               onClick={() => handleAction(btn.action)}
//               sx={{
//                 padding: "12px 16px",
//                 fontSize: "12px",
//                 fontWeight: "600",
//                 backgroundColor:
//                   action === btn.action ? btn.color : "#878787ff",
//                 color: "#FFFFFF",
//                 borderRadius: "6px",
//                 textTransform: "none",
//                 transition: "all 0.3s ease",
//                 border: action === btn.action ? `2px solid ${btn.color}` : "2px solid #878787ff",
//                 minHeight: "52px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 whiteSpace: "normal",
//                 lineHeight: "1.2",
//                 "&:hover": {
//                   backgroundColor: btn.color,
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//                 },
//                 "&:active": {
//                   transform: "translateY(0px)",
//                 },
//               }}
//             >
//               {btn.label}
//             </Button>
//           ))}
//         </Box>
//       </Box>
//     );
//   };

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         minHeight: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         backgroundColor: "#FFFFFF",
//       }}
//     >
//       <HeaderBannerPage />
//       <Box
//         sx={{
//           padding: "1px",
//           fontFamily: "Arial, sans-serif",
//           flex: 1,
//           overflowY: "auto",
//           backgroundColor: "#FFFFFF",
//         }}
//       >
//         {renderActionButtons()}

//         {action === "location" && (
//           <Box sx={{ mt: 1 }}>
//             <LocationBasedEmp />
//           </Box>
//         )}
//         {action === "rosterAttendance" && (
//           <Box sx={{ mt: 1 }}>
//             <RosterAttendance />
//           </Box>
//         )}
//         {action === "absentListRoster" && (
//           <Box sx={{ mt: 1 }}>
//             <RosterAbsentList />
//           </Box>
//         )}
//         {action === "Allocation" && (
//           <Box sx={{ mt: 1 }}>
//             <EmpAllocation />
//           </Box>
//         )}
//         {action === "supervisor" && (
//           <Box sx={{ mt: 3 }}>
//             <SupervisorWiseOT />
//           </Box>
//         )}
//         {action === "nonAllocated" && (
//           <Box sx={{ mt: 3 }}>
//             <NonAllocatedEmp />
//           </Box>
//         )}
//         {action === "EmpDiscripency" && (
//           <Box sx={{ mt: 0 }}>
//             <EmpDiscripency />
//           </Box>
//         )}
//         {action === "EWODiscripency" && (
//           <Box sx={{ mt: 3 }}>
//             <EWODiscripency />
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default OTTableViews;